import React from 'react';

import { ChildrenProps } from '@project/types';

export const FormScreenContainer: React.FC<ChildrenProps> = ({ children }) => {
  return <div className="mx-auto mt-10 flex flex-col items-center justify-center">{children}</div>;
};
